<template>
  <div class="row mx-0">
    <commonQueryInput
      :inputItems="multiInputItems"
      v-model:getValue="multiInputVal"
    ></commonQueryInput>
    <div class="d-flex justify-content-end text-end">
      <div
        class="py-1 px-2"
        style="background: #c8c9ca; min-width: max-content"
      >
        <span>異動人員：{{ username }}</span>
      </div>
    </div>
    <div class="col-12">
      <div
        class="table-responsive my-2"
        style="max-height: 500px"
        ref="userTable"
      >
        <table class="table table-style" :class="{ mod: mod }">
          <thead>
            <tr>
              <th v-if="mod"></th>
              <th colspan="3">基本資料</th>
              <th :colspan="role.length">對應權限</th>
            </tr>
            <tr>
              <th v-if="mod">刪除</th>
              <th>帳號</th>
              <th>密碼</th>
              <th>名稱</th>
              <template v-if="role.length == 0">
                <th></th>
              </template>
              <template v-for="(item, index) in role">
                <th class="">{{ item.name }}</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-if="add">
              <tr>
                <td>
                  <input
                    type="text"
                    name="userId"
                    v-model="addUser_role.user_id"
                    class="w-100"
                  />
                </td>
                <td>
                  <input
                    type="password"
                    name="password"
                    v-model="addUser_role.pwd"
                    class="w-100"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="userName"
                    v-model="addUser_role.name"
                    class="w-100"
                    autocomplete="off"
                  />
                </td>
                <template v-for="(roleItem, roleIndex) in role">
                  <td
                    class="changeAccessStyle"
                    @click="changeAccess('add', index, roleItem.role_id)"
                  >
                    <template
                      v-if="
                        addUser_role.role_data.indexOf(roleItem.role_id) >= 0
                      "
                    >
                      V
                    </template>
                  </td>
                </template>
              </tr>
            </template>
            <template v-for="(item, index) in user_role">
              <tr>
                <td v-if="mod">
                  <input
                    type="checkbox"
                    name="delCheckbox"
                    :value="item.user_id"
                    v-model="delCheckbox"
                  />
                </td>
                <td>{{ item.user_id }}</td>
                <td>
                  <template v-if="mod">
                    <input
                      type="password"
                      name="password"
                      v-model="user_role[index].pwd"
                      placeholder="***********"
                      class="w-100"
                    />
                  </template>
                  <template v-else>***********</template>
                </td>
                <td>
                  <template v-if="mod">
                    <input
                      type="text"
                      name="userName"
                      v-model="user_role[index].name"
                      class="w-100"
                      autocomplete="off"
                    />
                  </template>
                  <template v-else>
                    {{ item.name }}
                  </template>
                </td>
                <template v-for="(roleItem, roleIndex) in role">
                  <td
                    class=""
                    :class="{ changeAccessStyle: mod }"
                    @click="
                      mod ? changeAccess('mod', index, roleItem.role_id) : ''
                    "
                  >
                    <template
                      v-if="item.role_data.indexOf(roleItem.role_id) >= 0"
                    >
                      V
                    </template>
                  </td>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="gap-2 d-md-flex justify-content-md-end">
      <template v-if="add == true">
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="back"
        >
          取消新增
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="addUserCheck"
        >
          確認新增
        </button>
      </template>
      <template v-else-if="mod == true">
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="back"
        >
          取消修改
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="modUserCheck"
        >
          確定修改
        </button>
      </template>
      <template v-else>
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="addUser"
        >
          新增
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="modUser"
        >
          進行修改
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { computed, inject, ref, watch } from "vue";
import commonQueryInput from "@/components/commonQueryInput.vue";
import store from "@/store";
export default {
  components: {
    commonQueryInput,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const account = ref(loginData.value.account);
    const username = ref(loginData.value.username);

    const path = inject("path");
    const userOption = ref([]);
    const roleOption = ref([]);
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "category",
        label: "類別",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇類別 --",
        options: [
          { text: "使用者", value: "user" },
          { text: "角色", value: "role" },
        ],
      },
      {
        key: "itemValue",
        label: "項目編號/名稱",
        type: "selectInputList",
        bindKey: "category",
        disableText: "-- 選擇項目編號/名稱 --",
        bindOptions: {
          user: computed(() => userOption.value),
          role: computed(() => roleOption.value),
        },
      },
    ]);

    const userTable = ref(null);
    const add = ref(false);
    const mod = ref(false);
    const addUser_role = ref({});
    const orgUser_role = ref({});

    const addUser = () => {
      addUser_role.value = {
        user_id: "",
        name: "",
        pwd: "",
        role_data: [],
      };
      add.value = true;
      mod.value = false;
      userTable.value.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    const modUser = () => {
      orgUser_role.value = JSON.parse(JSON.stringify(user_role.value));
      add.value = false;
      mod.value = true;
    };
    const back = () => {
      addUser_role.value = {};
      if (!isEmptyObject(orgUser_role.value)) {
        user_role.value = JSON.parse(JSON.stringify(orgUser_role.value));
      }
      add.value = false;
      mod.value = false;
      delCheckbox.value = [];
    };
    const addUserCheck = () => {
      console.log(addUser_role.value);
      if (addUser_role.value.user_id == "") {
        methods.setTimeoutAlert("帳號不可為空");
        return;
      } else if (addUser_role.value.pwd == "") {
        methods.setTimeoutAlert("密碼不可為空");
        return;
      } else if (addUser_role.value.pwd.length > 16) {
        methods.setTimeoutAlert("密碼不可超過16位元");
      } else if (addUser_role.value.name == "") {
        methods.setTimeoutAlert("名稱不可為空");
        return;
      }

      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "AddUserRole";
      params["addUser_role"] = addUser_role.value;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          methods.triggerLoadingBar();
          methods.setTimeoutAlert("新增完成");
          queryUserRole("user", addUser_role.value.user_id);
        } else {
          methods.setTimeoutAlert(response);
          methods.triggerLoadingBar();
        }
      });
    };
    const modUserCheck = () => {
      const updateData = {
        namePwdUpdate: [],
        roleDataUpdate: [],
        deletedUsers: [],
      };

      // 檢查被刪除的用戶
      delCheckbox.value.forEach((id) => {
        const userIndex = user_role.value.findIndex(
          (user) => user.user_id === id
        );
        if (userIndex !== -1) {
          const orgUser = orgUser_role.value[userIndex]; // 從 orgUser_role 中獲取原始數據
          updateData.deletedUsers.push({
            user_id: id,
            role_data: orgUser.role_data,
          });
          // 移除被刪除的用戶
          user_role.value.splice(userIndex, 1);
          orgUser_role.value.splice(userIndex, 1); // 同時也從 orgUser_role 中移除相應的元素
        }
      });

      user_role.value.forEach((item, index) => {
        const orgItem = orgUser_role.value[index];

        if (item.name !== orgItem.name || item.pwd !== "") {
          // 如果name或pwd有修改，將該項目添加到namePwdUpdate中
          updateData.namePwdUpdate.push(item);
        }

        const addedRoles = item.role_data.filter(
          (role) => !orgItem.role_data.includes(role)
        );
        const removedRoles = orgItem.role_data.filter(
          (role) => !item.role_data.includes(role)
        );

        if (addedRoles.length > 0 || removedRoles.length > 0) {
          // 如果role_data有修改，將新增或移除的角色記錄到updateData.roleDataUpdate中
          updateData.roleDataUpdate.push({
            user_id: item.user_id,
            addedRoles,
            removedRoles,
          });
        }
      });

      console.log(updateData);
      if (
        updateData.namePwdUpdate.length === 0 &&
        updateData.roleDataUpdate.length === 0 &&
        updateData.deletedUsers.length === 0
      ) {
        methods.setTimeoutAlert("無修改項目");
        return;
      }

      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateUserRole";
      params["updateData"] = updateData;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          methods.triggerLoadingBar();
          methods.setTimeoutAlert("修改完成");
          orgUser_role.value = {};
          queryUserRole();
        } else {
          methods.setTimeoutAlert(response);
          methods.triggerLoadingBar();
        }
      });
    };

    //判斷是否為空物件
    function isEmptyObject(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }

    const role = ref([]);
    const user_role = ref([]);

    const delCheckbox = ref([]);

    const changeAccess = (category = "add", index = 0, role_id) => {
      if (category == "add") {
        const roleIndex = addUser_role.value.role_data.indexOf(role_id);

        if (roleIndex === -1) {
          addUser_role.value.role_data.push(role_id);
        } else {
          addUser_role.value.role_data.splice(roleIndex, 1);
        }
      } else if (category == "mod") {
        const userRole = user_role.value[index];
        const roleIndex = userRole.role_data.indexOf(role_id);

        if (roleIndex === -1) {
          userRole.role_data.push(role_id);
        } else {
          userRole.role_data.splice(roleIndex, 1);
        }
      }
    };

    const queryUserRole = (selectKey = undefined, selectValue = undefined) => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "QueryUserRole";
      firstQuery.value == false ? (params["firstQuery"] = true) : "";
      selectKey != undefined ? (params["selectKey"] = selectKey) : "";
      selectValue != undefined ? (params["selectValue"] = selectValue) : "";
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          user_role.value = QueryTableData["user_role_data"];
          if (!firstQuery.value) {
            role.value = QueryTableData["role_data"];
            userOption.value = QueryTableData["user_option"];
            roleOption.value = QueryTableData["role_option"];
            firstQuery.value = true;
          }
        } else {
          methods.setTimeoutAlert(response);
        }
        back();
        methods.triggerLoadingBar();
      });
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        console.log(newValue);
        queryUserRole(newValue.category, newValue.itemValue);
      },
      { deep: true }
    );

    const firstQuery = ref(false);
    queryUserRole();

    return {
      username,
      multiInputVal,
      multiInputItems,
      userTable,
      add,
      mod,
      addUser_role,
      addUser,
      modUser,
      back,
      addUserCheck,
      modUserCheck,
      role,
      user_role,
      delCheckbox,
      changeAccess,
    };
  },
};
</script>

<style scoped>
thead > tr:nth-child(1) > th {
  background: #4b8c80;
  color: #ffffff;
}
thead > tr:nth-child(2) > th {
  background: #ccc;
  color: #000;
}
.table {
  white-space: nowrap;
}
.table > thead,
.table > thead > tr:nth-child(1) > th:nth-child(1) {
  position: sticky;
  top: 0;
  z-index: 2;
}
.table > thead > tr > th:nth-child(1),
.table > tbody > tr > td:nth-child(1) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 150px;
  min-width: 150px;
  position: sticky;
  left: 0;
}
.table > thead > tr > th:nth-child(2),
.table > tbody > tr > td:nth-child(2) {
  width: 100px;
  min-width: 100px;
  position: sticky;
  left: 150px;
}
.table > thead > tr > th:nth-child(3),
.table > tbody > tr > td:nth-child(3) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 150px;
  min-width: 150px;
  position: sticky;
  left: 250px;
}
.table.mod > thead,
.table.mod > thead > tr:nth-child(1) > th:nth-child(1),
.table.mod > thead > tr:nth-child(1) > th:nth-child(2),
.table.mod > thead > tr:nth-child(2) > th:nth-child(3),
.table.mod > thead > tr:nth-child(2) > th:nth-child(4) {
  position: sticky;
  top: 0;
  z-index: 2;
}
.table.mod > thead > tr:nth-child(1) > th:nth-child(2) {
  left: 65px;
}
.table.mod > thead > tr > th:nth-child(1),
.table.mod > tbody > tr > td:nth-child(1) {
  width: 65px;
  min-width: 65px;
  position: sticky;
  left: 0;
}
.table.mod > thead > tr > th:nth-child(2),
.table.mod > tbody > tr > td:nth-child(2) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 150px;
  min-width: 150px;
  position: sticky;
  left: 65px;
}
.table.mod > thead > tr > th:nth-child(3),
.table.mod > tbody > tr > td:nth-child(3) {
  width: 100px;
  min-width: 100px;
  position: sticky;
  left: 215px;
}
.table.mod > thead > tr > th:nth-child(4),
.table.mod > tbody > tr > td:nth-child(4) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 150px;
  min-width: 150px;
  position: sticky;
  left: 315px;
}
.changeAccessStyle {
  cursor: pointer;
}
</style>
